import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import { Grid } from '@coursera/cds-core';

import { useDegreeMyPageHeader } from 'bundles/composable-page-header-degree/contexts/DegreeMyPageHeaderContext';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NotificationsLegacyGridItem from 'bundles/composable-page-header/components/grid-items/NotificationsLegacyGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileAccountMenuGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileAccountMenuGridItem';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import AccountMenuConfig from 'bundles/composable-page-header/components/mobile-menu-items/AccountMenuConfig';
import DefaultLoggedInMobileMenuConfig from 'bundles/composable-page-header/module-renderers/DefaultLoggedInMobileMenuConfig';
import DefaultLoggedOutMobileMenuConfig from 'bundles/composable-page-header/module-renderers/DefaultLoggedOutMobileMenuConfig';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

import _t from 'i18n!nls/composable-page-header-degree';

const DegreeMobileMainNav = () => {
  const {
    chosenEnterpriseProgram,
    enrolledDegreePrograms,
    enrolledEnterprisePrograms,
    chosenDegree,
    hasEnrolledPrograms,
    naptimeManagedThirdPartyOrganizations,
    hasCheatingIncidents,
    canViewEducatorAdminLink,
    isCourseraPlusLearner,
    courseraPlusSubscriptionCycle,
    naptimeChosenOrganization,
    naptimeOrganizationsWithProgramEnrollments,
  } = useDegreeMyPageHeader();

  const isLoggedIn = !!userGet()?.id;
  const isOrgScoped = GrowthDiscoveryEpicClient.preview('orgScopedHome');
  const mobileConfigToUse = () => {
    if (isLoggedIn) {
      return (
        <DefaultLoggedInMobileMenuConfig
          enrolledDegreePrograms={enrolledDegreePrograms}
          enrolledEnterprisePrograms={enrolledEnterprisePrograms}
          isCourseraPlusLearner={isCourseraPlusLearner}
          chosenDegree={chosenDegree}
          chosenEnterpriseProgram={chosenEnterpriseProgram}
          hasEnrolledPrograms={!!hasEnrolledPrograms}
          naptimeManagedThirdPartyOrganizations={naptimeManagedThirdPartyOrganizations}
          hasCheatingIncidents={hasCheatingIncidents}
          canViewEducatorAdminLink={canViewEducatorAdminLink}
          courseraPlusSubscriptionCycle={courseraPlusSubscriptionCycle}
        />
      );
    } else {
      return <DefaultLoggedOutMobileMenuConfig />;
    }
  };

  return (
    <MainNavigationWrapper>
      <Grid item xs={8} sm={6} container alignItems="center">
        <MobileMenuIconGridItem
          menuConfig={mobileConfigToUse()}
          homeLogo={
            <HomeLogoGridItemModule
              href={`/degrees/${chosenDegree?.slug}/home`}
              ariaLabel={_t('#{degreeName} home page | Coursera', { degreeName: chosenDegree?.name || 'Degree' })}
              logos={[<CourseraHomeLogo key="1" />]}
            />
          }
        />
        <HomeLogoGridItemModule
          href={`/degrees/${chosenDegree?.slug}/home`}
          ariaLabel={_t('#{degreeName} home page | Coursera', { degreeName: chosenDegree?.name || 'Degree' })}
          logos={[<CourseraHomeLogo key="1" />]}
        />
      </Grid>
      <Grid item container xs={4} sm={6} alignItems="center" justifyContent="flex-end">
        <NotificationsLegacyGridItem />
        {isOrgScoped && isLoggedIn && (
          <MobileAccountMenuGridItem
            isCourseraPlusLearner={!!isCourseraPlusLearner}
            menuConfig={
              <AccountMenuConfig
                hasEnrolledPrograms={!!hasEnrolledPrograms}
                naptimeManagedThirdPartyOrganizations={naptimeManagedThirdPartyOrganizations}
                canViewEducatorAdminLink={canViewEducatorAdminLink}
                hasCheatingIncidents={hasCheatingIncidents}
                currentOrganization={naptimeChosenOrganization}
                currentDegree={chosenDegree}
                degrees={enrolledDegreePrograms}
                organizations={naptimeOrganizationsWithProgramEnrollments}
              />
            }
          />
        )}
      </Grid>
    </MainNavigationWrapper>
  );
};

export default DegreeMobileMainNav;
